import api from '../api';

export function login(email, password, remember) {
    return api.post('/auth', {
        'email': email,
        'password': password,
        'remember': remember
    }).then(response => response.data);
}

export function logout() {
    return api.delete('/auth');
}

export function user() {
    return api.get('/user').then(response => {
        return response.data
    });
}

export function signup(firstname, lastname, email, organisation) {
    return api.post(`/signup`, {
        'firstname': firstname,
        'lastname': lastname,
        'email': email,
        'organisation': organisation,
    })
}
